import createStore from "astrid-helpers/src/createStore";

export const [getTool, setTool, useTool] = createStore();
